import { SHOW_PLAID_INFO_MESSAGE } from './actions';

export interface PlaidState {
  isPlaidInfoMessageVisible: boolean;
}

const initialState: PlaidState = {
  isPlaidInfoMessageVisible: false,
};

export const plaidReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SHOW_PLAID_INFO_MESSAGE: {
      return { ...state, isPlaidInfoMessageVisible: payload };
    }

    default: {
      return state;
    }
  }
};
